import BulkUpdateTestCaseModal from './bulkUpdateTestCasesModal/bulkUpdateTestCaseModal';

export default BulkUpdateTestCaseModal;
